import { useEffect } from 'react';

import { refreshBannersInModalBackground } from '../components/Banners/utils/banners';

const useRefreshEssentialBanners = () => {
  useEffect(() => {
    refreshBannersInModalBackground();
  }, []);
};

export default useRefreshEssentialBanners;
